import { shade } from 'polished';
import React from 'react';
import styled from 'styled-components';
import { buttonResetStyleIncludingFocus } from '../../../../../commonStyles/buttonReset';
import colors from '../../../../../helpers/colors';
import fonts from '../../../../../helpers/fonts';
import mediaQuery from '../../../../../helpers/mediaQuery';
import spacing from '../../../../../helpers/spacing';
import { GridItem } from '../../../../Grid';
import Image from '../../../../Image';
import { desktopHeaderHeight } from '../../../DoubleHeader/styles';
import { navItemSelectedBarHeight } from '../../../Header/styles';
import { focusBoxShadowWidthPx, NavItemText, transitionLength } from '../../styles';
import { secondarySectionProps } from './layout';

export const NavLink = styled.a`
  ${buttonResetStyleIncludingFocus};
  position: relative;
  text-decoration: none;
  display: flex;
  align-items: center;

  transition: background-color ${transitionLength} ease-out;

  &:hover {
    background: ${({ theme }) => shade(0.3, theme.colors.core02)};
  }

  height: calc(100% - ${focusBoxShadowWidthPx}px);
  margin: ${focusBoxShadowWidthPx / 2}px ${spacing(4)};

  :first-child {
    margin-left: 0;
  }

  &:focus-visible {
    /* Have half of the border inset and half on the outside so that it will overlap
    the divider line between the nav items. */
    box-shadow: inset ${colors.neutral08} 0 0 0 ${focusBoxShadowWidthPx / 2}px,
      ${colors.neutral08} 0 0 0 ${focusBoxShadowWidthPx / 2}px;
    border-radius: 8px;
    /* Put the focussed element above its neighbours to ensure nothing overlaps the
    focus outline. */
    z-index: 1;
  }

  &:hover ${NavItemText} {
    & {
      font-weight: unset;
    }
  }

  &:after {
    content: '';
    border-bottom: solid ${navItemSelectedBarHeight} ${colors.navigationHighlight};
    transform: scaleX(0);
    transition: transform ${transitionLength} ease-out;

    position: absolute;
    top: calc(${desktopHeaderHeight} - ${focusBoxShadowWidthPx / 2}px);
    width: 100%;
  }

  &:hover:after {
    transform: scaleX(1);
  }

  /* In chrome, the box shadow doesn't completely hide the dividers, so make the relevant
  ones transparent on focus.  */
  &:focus-visible ${NavItemText}, &:focus-visible + button ${NavItemText} {
    border-color: transparent;
  }
`;

export const DummySecondarySection: React.FC = () => (
  <GridItem {...secondarySectionProps} />
);

export const Section = styled(GridItem)`
  && {
    margin-top: ${spacing(3)};
    margin-bottom: ${spacing(4)};

    &:last-child {
      padding-left: ${spacing(4)};
      border-left: 1px ${colors.neutral04} solid;
    }
  }
`;

export const SectionHeading = styled.h3`
  ${fonts.headingSmall}
  margin: 0 0 ${spacing(3)} 0;
`;

export const SectionLinks = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

export const LinkWrapper = styled.li`
  ${fonts.paragraph}

  margin: ${spacing(1)} 0;
`;

export const UspBody = styled.div`
  ${fonts.paragraph}
  margin: ${spacing(2)} 0;
`;

export const UspContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
export const UspHeader = styled.div`
  display: flex;
  flex-direction: row;
  ${SectionHeading} {
    margin: 10px 0 0 0;
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: baseline;
  margin-bottom: ${spacing(2)};

  ${mediaQuery.tabletPortrait`
    margin: 0 ${spacing(3)} 0 0;
  `}
`;

export const StyledImage = styled(Image)`
  width: ${spacing(15.75)};
  border-radius: 0;
`;
